import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

export type { ClassValue }

/**
 * `clsx` resolves conditionals; `tailwind-merge` resolves *conflicts*, so a caller's
 * `className` always beats the variant defaults baked into a component.
 *
 * Without the merge step `cn('ps-4', 'ps-2')` emits both and the winner is decided by
 * stylesheet order — i.e. by whichever utility Tailwind happened to generate last. That is
 * not a contract we can hand to consumers.
 *
 * tailwind-merge 3.x understands the logical-property utilities this package is required
 * to use (`ps-*`, `pe-*`, `ms-*`, `me-*`, `start-*`, `end-*`, `border-s-*`, `border-e-*`),
 * and it also understands that a logical utility conflicts with its physical counterpart —
 * which matters because app code may still pass a physical class in.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs))
}
